import { notesServiceProxy } from '../servicePool';
import { ListResultDtoOfSearchOutputDto } from '../service-proxies';

export function getNotes(): Promise<ListResultDtoOfSearchOutputDto> {
  return notesServiceProxy.searchNotes(100, '');
}